import React, {useContext} from "react";
import {makeStyles} from "@material-ui/core/styles";
import AppStore from "../AppStore";
import {LinearProgress, Box} from "@material-ui/core";


const useStyles = makeStyles((theme) => ({
    container: {
        width: '100%',
        marginTop: theme.spacing(10),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: theme.spacing(3)
    }
}));

export default function Loader() {
    const classes = useStyles();
    const appStore = useContext(AppStore);

    return (
        <div className={classes.container}>
            <img
                src={appStore.getResortData()['options']['urlLogo']}
                alt={""}
                width={"200"}
                className={"mb-3"}
            />

            <Box width={"200px"} mt={3}>
                <LinearProgress />
            </Box>
        </div>
    );
}
